import { colors } from "@pentacode/core";
import type { PentacodeAPIModels } from "@pentacode/rest";
import { html } from "lit";

export function renderFilter(company: PentacodeAPIModels["Company"], filter: PentacodeAPIModels["EntityFilter"]) {
    switch (filter.type) {
        case "venue": {
            const venue = company.venues.find((v) => v.id === filter.value);
            if (!venue) {
                return;
            }
            return html`<div class="pill"><ptc-ui-icon name="icon.object.venue"></ptc-ui-icon> ${venue.name}</div>`;
        }
        case "department": {
            const department = company.venues.flatMap((venue) => venue.departments).find((v) => v.id === filter.value);
            if (!department) {
                return;
            }

            return html`<div
                class="pill"
                style="--color-highlight: ${(department.color && colors[department.color]) || department.color}"
            >
                <ptc-ui-icon name="icon.object.department"></ptc-ui-icon> ${department.name}
            </div>`;
        }
    }
}

export function renderFilters(company: PentacodeAPIModels["Company"], filters: PentacodeAPIModels["EntityFilter"][]) {
    return html` <div class="pills">
        ${filters.length
            ? filters.map((filter) => renderFilter(company, filter))
            : html`<div class="subtle pill">Gesamtes Unternehmen</div>`}
    </div>`;
}
